/**
 * Headless root for the home health demo layer, mounted once in AuthenticatedRoot.
 * Hosts background work that must run on every page while the layer is enabled,
 * and hands the Apollo client to the presenter actions (which run outside React).
 */
import { useEffect } from "react";
import { useApolloClient } from "@apollo/client";
import { useOrganization } from "~/providers/GraphqlProvider";
import { useOrgConfig } from "~/providers/OrgConfigProvider";
import { CoverageDrawer } from "./components/CoverageDrawer";
import { HorizonFetcher } from "./data/HorizonFetcher";
import { isHomeHealthDemoEnabled } from "./demoEnabled";
import { attachApolloClient, attachOrgConfig } from "./presenter/actions";

export function HomeHealthDemoRoot() {
  const { organizationName } = useOrganization();
  const client = useApolloClient();
  const orgConfig = useOrgConfig();
  const enabled = isHomeHealthDemoEnabled(organizationName);
  useEffect(() => {
    if (enabled) attachApolloClient(client);
  }, [client, enabled]);
  // The drive-time recompute a move runs reads the organization's visit-resource
  // requirements and shift centres, which is all `useOrgConfig()` is wanted for
  // here. It hands back a fresh object when its own query resolves, so the empty
  // one is not attached.
  useEffect(() => {
    if (enabled && !orgConfig.loading) attachOrgConfig(orgConfig);
  }, [orgConfig, enabled]);
  if (!enabled) return null;
  return (
    <>
      <HorizonFetcher />
      <CoverageDrawer />
    </>
  );
}
